import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

const drawerWidth = 240;

const styles = () => ({
    appBar: {
        width: `calc(100% - ${drawerWidth}px)`,
        left: drawerWidth,
        zIndex: 100,
    },
});

class TopBar extends Component {
    render() {
        const { classes } = this.props;

        return (
            <div>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="title" color="inherit" className={classes.flex}>
                            {this.props.title}
                        </Typography>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

TopBar.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TopBar);


// WEBPACK FOOTER //
// ./src/site/TopBar.js